import PersonIcon from '@material-ui/icons/Person';
import UserCreate from './UserCreate';
import BackOfficeUserList from './backOfficeUserList';

export default {
    list: BackOfficeUserList,
    create : UserCreate,
    icon: PersonIcon,
};
